import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'IT-My-Account-Banner-eSpot_rv' }
];
export default contentItems;